import { createContext, useContext, useState } from "react";
import ConsultationDialog from "@/components/ConsultationDialog";

const ConsultationContext = createContext(null);

export function ConsultationProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openConsultation = () => setOpen(true);
  return (
    <ConsultationContext.Provider value={{ openConsultation }}>
      {children}
      <ConsultationDialog open={open} onOpenChange={setOpen} />
    </ConsultationContext.Provider>
  );
}

export const useConsultation = () => useContext(ConsultationContext);
